/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type DashboardDropDown_category = {
    readonly categories: ReadonlyArray<{
        readonly isNull: boolean;
        readonly name: string;
        readonly key: string;
        readonly yesterdaysSalesToDate: number;
        readonly currentMonthToDate: number;
        readonly lastMonthMonthToDate: number;
        readonly lastMonth: number;
    }>;
    readonly totalRollup: {
        readonly isNull: boolean;
        readonly name: string;
        readonly key: string;
        readonly yesterdaysSalesToDate: number;
        readonly currentMonthToDate: number;
        readonly lastMonthMonthToDate: number;
        readonly lastMonth: number;
    };
    readonly " $refType": "DashboardDropDown_category";
};
export type DashboardDropDown_category$data = DashboardDropDown_category;
export type DashboardDropDown_category$key = {
    readonly " $data"?: DashboardDropDown_category$data;
    readonly " $fragmentRefs": FragmentRefs<"DashboardDropDown_category">;
};



const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isNull",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "key",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "yesterdaysSalesToDate",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "currentMonthToDate",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "lastMonthMonthToDate",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "lastMonth",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DashboardDropDown_category",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "DetailedSalesReportSales",
      "kind": "LinkedField",
      "name": "categories",
      "plural": true,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "DetailedSalesReportSales",
      "kind": "LinkedField",
      "name": "totalRollup",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": null
    }
  ],
  "type": "DetailedSalesReportCategory",
  "abstractKey": null
};
})();
(node as any).hash = 'ceead837d04ba70d64bf1ed045e00c32';
export default node;
